import { useContext, useEffect } from "react";
import "./index.scss";
import React from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import { useTableContext } from "../../contexts/TableContext";
import { MyContext } from "../../contexts/ContextProvider";

const creationCheck = Yup.object().shape({
  code: Yup.string().required("A currency code is required"),
  name: Yup.string().required("An currency name is required"),
  country: Yup.string().required("You must select a country"),
});

const CurrencyCreationForm = ({ submitForm, closeForm, countries }) => {
  const { loading } = useTableContext();
  const { currencyCode } = useContext(MyContext)
  return (
    <div className="exchange-form">
      <h2>Create A Currency</h2>
      <Formik
        initialValues={{
          code: "",
          name: "",
          country: "",
        }}
        onSubmit={(values) => {
          submitForm(values);
        }}
        validationSchema={creationCheck}
      >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit} id="creationform">
            <div className={`field select`}>
              <label htmlFor="code">Currency Code</label>
              <Field
                name="code"
                as="select"
                id={`code`}
                value={values.code}
                onChange={handleChange}
                className="__form-input"
              >
                <option value="">Select a currency code.</option>
                {currencyCode?.map((item, index) => (
                  <option key={index} value={item?.code}>
                    {item?.code}
                  </option>
                ))}
              </Field>
              {errors.code && touched.code ? (
                <div className="error">{errors.code}</div>
              ) : null}
            </div>
            <div className={`field select`}>
              <label htmlFor="name">Currency Name</label>
              <Field
                name="name"
                as="select"
                id={`name`}
                value={values.name}
                onChange={handleChange}
                className="__form-input"
              >
                <option value="">Select a currency name.</option>
                {currencyCode?.map((item, index) => (
                  <option key={index} value={item?.name}>
                    {item?.name}
                  </option>
                ))}
              </Field>
              {errors.name && touched.name ? (
                <div className="error">{errors.name}</div>
              ) : null}
            </div>
            <div className={`field select`}>
              <label htmlFor="country">List of Active Countries.</label>
              <Field
                name="country"
                as="select"
                id={`country`}
                value={values.country}
                onChange={handleChange}
                className="__form-input"
              >
                <option value="">Select a country.</option>
                {countries
                  .filter(
                    (item) => item.status === "ACTIVE" || item.name === "Nigeria"
                  )
                  .reduce((unique, country) => {
                    if (!unique.some((item) => item.name === country.name)) {
                      unique.push(country);
                    }
                    return unique;
                  }, [])
                  .map((country, index) => (
                    <option key={country?.id || index} value={country?.id}>
                      {country?.name}
                    </option>
                  ))}
              </Field>
              {errors.country && touched.country ? (
                <div className="error">{errors.country}</div>
              ) : null}
            </div>

            <div className="button-sec">
              <button
                type="button"
                className="cancel-btn"
                disabled={loading}
                onClick={closeForm}
              >
                {!loading && <span>Cancel</span>}
                {loading && <span>Canceling ...</span>}
              </button>
              <button className="create-btn" type="submit" disabled={loading}>
                {!loading && <span>Create</span>}
                {loading && <span>Submitting ...</span>}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};
export default CurrencyCreationForm;
